/* ===========================
   HYBRID WISHLIST SYSTEM
   (c) Tornado Store
=========================== */

window.Wishlist = {
  key: 'tornado_wishlist_items', // full product objects
  syncKey: 'tornado_wishlist_sync', // handles we last synced
  staleAfter: 86400, // 24 hours

  /* -------------------------
     Retrieve LS product list
  -------------------------- */
  get() {
    try {
      const raw = localStorage.getItem(this.key);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch {
      return [];
    }
  },

  /* -------------------------
     Save product list
  -------------------------- */
  save(list) {
    localStorage.setItem(this.key, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  },

  /* -------------------------
     Add product (object)
  -------------------------- */
  add(product) {
    const list = this.get();
    const exists = list.find((p) => p.handle === product.handle);
    if (!exists) {
      product.updated_at = Date.now() / 1000;
      list.push(product);
      this.save(list);
    }
    this.syncToShopify();
  },

  /* -------------------------
     Remove by handle
  -------------------------- */
  remove(handle) {
    const list = this.get().filter((p) => p.handle !== handle);
    this.save(list);
    this.syncToShopify();
  },

  /* -------------------------
     Toggle wishlist
  -------------------------- */
  toggle(product) {
    const list = this.get();
    const exists = list.find((p) => p.handle === product.handle);

    if (exists) {
      this.remove(product.handle);
      showWishlistModal(false, product.title);
      return false;
    } else {
      this.add(product);
      showWishlistModal(true, product.title);
      return true;
    }
  },
  /* -------------------------
     Check stale product
  -------------------------- */
  isStale(product) {
    return Date.now() / 1000 - product.updated_at > this.staleAfter;
  },

  /* -------------------------
     Refresh stale product via /products/{handle}.js
  -------------------------- */
  async refreshProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const data = await res.json();

      return {
        id: data.id,
        handle: data.handle,
        title: data.title,
        url: data.url,
        image: data.images[0],
        second_image: data.images[1] || null,
        price: data.price,
        compare_price: data.compare_at_price,
        updated_at: Date.now() / 1000,
      };
    } catch (err) {
      console.warn('Wishlist refresh failed:', err);
      return null;
    }
  },

  /* -------------------------
     Refresh stale items
  -------------------------- */
  async refreshStaleItems() {
    let list = this.get();
    let updated = false;

    for (let i = 0; i < list.length; i++) {
      if (this.isStale(list[i])) {
        const newProduct = await this.refreshProduct(list[i].handle);
        if (newProduct) {
          list[i] = newProduct;
          updated = true;
        }
      }
    }

    if (updated) this.save(list);
  },

  /* ============================================================
     🟧 CUSTOMER TAG SYNC (handles only, not full product objects)
  ============================================================ */

  syncToShopify() {
    if (!window.themeCustomerEmail) return;

    const list = this.get().map((p) => p.handle);
    localStorage.setItem(this.syncKey, JSON.stringify(list));

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        form_type: 'customer',
        'contact[email]': window.themeCustomerEmail,
        'contact[tags]': 'wishlist:' + list.join(',wishlist:'),
      }),
    }).catch(() => {});
  },

  /* -------------------------
     Load wishlist from Shopify tags
  -------------------------- */
  async syncFromShopify(tags) {
    if (!tags || !tags.length) return;

    const handles = tags.filter((tag) => tag.startsWith('wishlist:')).map((tag) => tag.replace('wishlist:', ''));

    let list = this.get();

    // For handles missing in LS, fetch product.json
    for (const h of handles) {
      const exists = list.find((p) => p.handle === h);
      if (!exists) {
        const refreshed = await this.refreshProduct(h);
        if (refreshed) list.push(refreshed);
      }
    }

    this.save(list);
  },
};

/* Auto-refresh stale products after load */
document.addEventListener('DOMContentLoaded', () => {
  Wishlist.refreshStaleItems();
});

document.addEventListener('DOMContentLoaded', () => {
  updateWishlistCounter();

  // Update on any wishlist change
  document.addEventListener('wishlist:updated', updateWishlistCounter);
});

function updateWishlistCounter() {
  const el = document.getElementById('wishlist-count');
  if (!el) return;

  const list = Wishlist.get();
  const count = list.length;

  if (count > 0) {
    el.textContent = count;
    el.classList.remove('hidden');
  } else {
    el.classList.add('hidden');
  }
}

/* ===========================
   WISHLIST MODAL FUNCTIONS
=========================== */

function showWishlistModal(added, title) {
  const modal = document.getElementById('wishlistModal');
  const titleEl = document.getElementById('wishlistModalTitle');
  const msgEl = document.getElementById('wishlistModalMessage');

  if (!modal) return;

  if (added) {
    titleEl.textContent = 'Added to Wishlist';
    msgEl.textContent = `${title} has been added to your wishlist.`;
  } else {
    titleEl.textContent = 'Removed from Wishlist';
    msgEl.textContent = `${title} was removed from your wishlist.`;
  }

  modal.classList.remove('hidden');
  modal.classList.add('flex');

  // Auto-close after 3 seconds
  setTimeout(() => {
    closeWishlistModal();
  }, 2000);
}

function closeWishlistModal() {
  const modal = document.getElementById('wishlistModal');
  if (!modal) return;
  modal.classList.add('hidden');
  modal.classList.remove('flex');
}
/* ===========================
   END OF WISHLIST JS
=========================== */
